import { createBitkitToast } from '@bitrise/bitkit-v2';
import { useMutation } from '@tanstack/react-query';

import useInitialState from '@/hooks/useInitialState';
import { monolithApi } from '@/utils/api';
import { appWatchPath } from '@/utils/monolithApiRouteService';

const useWatchApp = (appSlug: string, initialWatching: boolean) => {
  const [isWatching, setWatching] = useInitialState(initialWatching);

  const shouldWatch = !isWatching;

  const mutation = useMutation({
    mutationFn: () => {
      return monolithApi.post<{ shouldWatch: boolean }>(appWatchPath(appSlug), {
        shouldWatch,
      });
    },
    onSuccess: () => {
      setWatching(shouldWatch);
    },
    onError: () => {
      createBitkitToast({
        messageText: `Failed to turn ${isWatching ? 'off' : 'on'} watching`,
        variant: 'critical',
      });
    },
  });

  return {
    isWatching,
    isLoading: mutation.isPending,
    toggleWatching: () => mutation.mutate(),
  };
};

export default useWatchApp;
